const { STATUS_NUMBER_TO_TEXT } = require("../enums/Status");
const { REASON_CODE_NUMBER_TO_TEXT } = require("../enums/ReasonCode");

/**
 * Checks if a given status and reason pair is valid.
 *
 * @param {number} status - The status number.
 * @param {number} reason - The reason code number.
 * @returns {boolean} - Returns true if the status and reason pair is valid, otherwise false.
 */
const isValidStatusAndReasonPair = (status, reason) => {
  if (
    !(status in STATUS_NUMBER_TO_TEXT) ||
    !(reason in REASON_CODE_NUMBER_TO_TEXT)
  ) {
    return false;
  }

  // Status should be the most significant digit of the reason code
  return `${reason}`.startsWith(`${status}`);
};

/**
 * Parses the status from the reason code.
 *
 * @param {number} reason - The reason code number.
 * @returns {number} - The status number.
 */
const parseStatusFromReasonCode = (reason) => {
  return parseInt(`${reason}`[0]);
};

module.exports = {
  isValidStatusAndReasonPair,
  parseStatusFromReasonCode,
};
